import React from "react";
import ControlDetailsPanel from "./ControlDetailsPanel";
import ValueTable, { TValueItem } from "./ValueTable";
import { IControlMieleDevice, TMieleValueAttribute } from "../types";
import { useTranslation } from "react-i18next";

interface IControlDetailsMieleDeviceProps {
  control: IControlMieleDevice;
}

const ControlDetailsMieleDevice = (props: IControlDetailsMieleDeviceProps) => {
  const { control } = props;
  const { t } = useTranslation();
  const items: TValueItem<TMieleValueAttribute>[] = [
    { name: t("Status"), attribute: "status" },
    { name: t("Start Time"), attribute: "start_time" },
    { name: t("Remaining Time"), attribute: "remaining_time" },
    { name: t("Elapsed Time"), attribute: "elapsed_time" },
    { name: t("Program ID"), attribute: "program_id" },
    { name: t("Program Type"), attribute: "program_type" },
    { name: t("Program Phase"), attribute: "program_phase" },
    { name: t("Target Temperature"), attribute: "target_temperature" },
    { name: t("Spinning Speed"), attribute: "spinning_speed" },
  ];
  return (
    <ControlDetailsPanel
      mode={control.is_enabled ? "on" : "disabled"}
      title={control.name}
    >
      <ValueTable control={control} items={items} />
    </ControlDetailsPanel>
  );
};

export default ControlDetailsMieleDevice;
